import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { downloadFileFromResponse } from '@cbridge-utils/file';
import { catchApiError, IClientApiDependencySegment } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { OrderLifetimeAction } from '../orderLifetime.action';

type IDependencies = IClientApiDependencySegment;

export const exportOrderLifetimeEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(OrderLifetimeAction.exportFile.started),
  mergeMap((params) => {
    return dependencies.api.exportOrderLifetimeProfiles().pipe(
      mergeMap((response) => {
        downloadFileFromResponse(response);
        return [];
      }),
      catchApiError((error) => {
        return [
          OrderLifetimeAction.exportFile.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
